<template>
  <section class="product-templates">
    <header>
      <h2>{{$t('products.templateTitle')}}</h2>
      <p class="subtitle is-hidden-mobile">
        {{$t('products.templateSubtitle')}}
      </p>
    </header>
    <div class="container">
      <!-- Desktop: 3 columns -->
      <div class="row templates-desktop hidden-xs">
        <div class="col-xs-4" v-for="(item, index) in templates" :key="'d'+index">
          <div class="product-templates-item">
            <cover-holder :height="height" :src="item.cover" />
            <div class="product-templates-item-info">
              <h4>{{item.label}}</h4>
              <p>{{$t('products.templateDesc')}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile: carousel -->
      <div class="templates-carousel visible-xs">
        <button class="carousel-arrow carousel-arrow--left" @click="prev" :disabled="current === 0">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div class="carousel-viewport">
          <div class="carousel-track" :style="{ transform: 'translateX(' + (-current * 100) + '%)' }">
            <div class="carousel-slide" v-for="(item, index) in templates" :key="'m'+index">
              <div class="product-templates-item">
                <cover-holder :height="height" :src="item.cover" />
                <div class="product-templates-item-info">
                  <h4>{{item.label}}</h4>
                  <p>{{$t('products.templateDesc')}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="carousel-arrow carousel-arrow--right" @click="next" :disabled="current === templates.length - 1">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
      <div class="carousel-dots visible-xs">
        <span v-for="(item, index) in templates" :key="'dot'+index"
              :class="{ active: current === index }"
              @click="current = index"></span>
      </div>
    </div>
  </section>
</template>

<script>
import CoverHolder from '../CoverHolder'
export default {
  name: 'ProductTemplates',
  components: { CoverHolder },
  computed: {
    templates () {
      return [
        {
          name: 'a5-waterfall',
          label: this.$t('products.a5Waterfall'),
          cover: require('../../../static/images/product/templates-1.png')
        },
        {
          name: 'a5-column',
          label: this.$t('products.a5DualColumn'),
          cover: require('../../../static/images/product/templates-2.png')
        },
        {
          name: 'a4-waterfall',
          label: this.$t('products.a4Waterfall'),
          cover: require('../../../static/images/product/templates-3.png')
        }
      ]
    }
  },
  data: () => ({
    height: 77,
    current: 0
  }),
  methods: {
    prev () {
      if (this.current > 0) this.current--
    },
    next () {
      if (this.current < this.templates.length - 1) this.current++
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';

.product-templates {
  // Desktop 3-column layout
  .templates-desktop {
    .product-templates-item {
      border-radius: 12px;
      overflow: hidden;
      text-align: center;
      box-shadow: 0px 12px 40px 0px rgba(175, 175, 175, 0.2);
      background: #fff;
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      }
    }
  }

  // Mobile carousel
  .templates-carousel {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    position: relative;
  }

  .carousel-viewport {
    flex: 1;
    overflow: hidden;
    border-radius: 12px;
  }

  .carousel-arrow--left,
  .carousel-arrow--right {
    position: absolute;
    top: 40%;
    transform: translateY(-50%);
    z-index: 2;
  }
  .carousel-arrow--left { left: 0.5rem; }
  .carousel-arrow--right { right: 0.5rem; }

  .carousel-track {
    display: flex;
    transition: transform 0.4s ease;
  }

  .carousel-slide {
    flex: 0 0 100%;
    min-width: 100%;

    .product-templates-item {
      border-radius: 12px;
      overflow: hidden;
      text-align: center;
      box-shadow: 0px 12px 40px 0px rgba(175, 175, 175, 0.2);
      background: #fff;
    }
  }

  .carousel-arrow {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.9);
    color: #374151;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    &:hover:not(:disabled) {
      background: #fff;
      color: $el-color-primary;
    }

    &:disabled {
      opacity: 0.3;
      cursor: default;
    }
  }

  .carousel-dots {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 1rem;

    span {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #d1d5db;
      cursor: pointer;
      transition: all 0.2s;

      &.active {
        background: $el-color-primary;
        width: 24px;
        border-radius: 4px;
      }
    }
  }

  &-item-info {
    font-size: 14px;
    padding: 1.25em;

    h4 {
      font-size: 1.125rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
    }

    p {
      color: #6b7280;
      line-height: 1.5;
    }
  }
}
</style>
